module.exports = __webpack_public_path__ + "static/media/repeat.90d24b04.svg";